import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELSELECTOPTIONBLOCK_LEGACY_FIELD_ORDER = [
  "label",
  "value"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelSelectOptionBlockDescriptor: _generatedCartFunnelSelectOptionBlockDescriptor,
  cartFunnelSelectOptionBlockBlocDefinition,
  cartFunnelSelectOptionBlockDashboardLayout,
  cartFunnelSelectOptionBlockConfig,
  cartFunnelSelectOptionBlockResolveConfig,
  cartFunnelSelectOptionBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Select input / Option item",
    componentType: 'CartFunnelSelectOptionBlockComponent',
    category: 'cart',
    description: "Cart funnel / Select input / Option item.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelSelectBlockComponent", slot: "options" },
    ],
    sharedFields: {}
  },

  () => ({
    label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-select-option.label.label",
        help: "pages.blocks.cart-funnel-select-option.label.help",
      }
    }),
    value: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-select-option.value.label",
        help: "pages.blocks.cart-funnel-select-option.value.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-select-option.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-select-option.fieldset.option.label",
            fields: ["label", "value"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelSelectOptionBlockDescriptor(): IBlockDescriptor;
export function cartFunnelSelectOptionBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelSelectOptionBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelSelectOptionBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelSelectOptionBlockDescriptor, cartFunnelSelectOptionBlockProperties, fieldOrder);
}

export {
  cartFunnelSelectOptionBlockBlocDefinition,
  cartFunnelSelectOptionBlockDashboardLayout,
  cartFunnelSelectOptionBlockProperties,
  cartFunnelSelectOptionBlockConfig,
  cartFunnelSelectOptionBlockResolveConfig,
};

export type CartFunnelSelectOptionBlockConfig = typeof cartFunnelSelectOptionBlockConfig;
